// The mini player: while narration is loaded and the reader is closed, a capsule at the bottom of the library and
// settings shows what's playing with back 15 / play-pause / forward 30. Tapping the title reopens the reader.
import { chunks, title } from "../model/article";
import { player } from "../narration/player";
import { h, icon } from "./dom";

export class MiniPlayer {
  readonly root: HTMLDivElement;
  private titleEl: HTMLButtonElement;
  private status: HTMLSpanElement;
  private playBtn: HTMLButtonElement;
  private shown = false;

  constructor(open: (id: string) => void) {
    this.status = h("span.mini-status");
    this.titleEl = h("button.mini-title", { title: "Open in the reader", onclick: () => { if (player.articleId) open(player.articleId); } });
    this.playBtn = h("button.icon-btn.play", { "aria-label": "Play", onclick: () => player.toggle(), dataset: { test: "mini-play" } }, icon("play"));
    this.root = h("div.mini-player", { role: "region", "aria-label": "Now playing", hidden: true },
      h("div.mini-text", null, this.titleEl, this.status),
      h("button.icon-btn", { "aria-label": "Back 15 seconds", title: "Back 15 s", onclick: () => player.skip(-15) }, icon("back15")),
      this.playBtn,
      h("button.icon-btn", { "aria-label": "Forward 30 seconds", title: "Forward 30 s", onclick: () => player.skip(30) }, icon("fwd30")));
    player.events.on("changed", () => this.update());
  }

  /** Shown only when something is loaded and `allowed` (the reader closed, signed in). */
  setAllowed(allowed: boolean) { this.shown = allowed; this.update(); }

  private update() {
    const a = player.article;
    const visible = this.shown && player.isLoaded && !!a;
    this.root.hidden = !visible;
    document.body.classList.toggle("has-mini-player", visible);
    if (!visible || !a) return;
    const st = player.state;
    const active = player.isActive;
    this.titleEl.textContent = title(a);
    this.playBtn.replaceChildren(icon(active ? "pause" : "play", 24));
    this.playBtn.setAttribute("aria-label", active ? "Pause" : "Play");
    this.playBtn.classList.toggle("busy", st.kind === "loading" || st.kind === "waiting");
    const n = chunks(a).length;
    this.status.textContent = st.kind === "loading" ? `Narrating part ${st.part + 1}…`
      : st.kind === "waiting" ? st.reason
      : st.kind === "failed" ? st.message
      : n > 1 ? `Part ${player.part + 1} of ${n}` : "";
  }
}
